import React from "react"
import GlobalContextProvider from "./src/context/GlobalContextProvider"

export const wrapRootElement = ({ element }) => {
  return <GlobalContextProvider>{element}</GlobalContextProvider>
}

// exports.onClientEntry = async () => {
//     if (typeof IntersectionObserver === "undefined") {
//         await import("intersection-observer")
//     }
// }